import {
  REACT_APP_API_BASEURL,
  REACT_APP_API_PROJECT_BASEURL,
  REACT_APP_AUDIT_LOG_BASEURL,
  REACT_APP_BULLETIN_BASEURL,
  REACT_APP_CRM_API_BASEURL,
  REACT_APP_DOCUMENTS_MS_API,
  REACT_APP_INVENTORY_MS_API,
  REACT_APP_LOGIN_AUTH,
  REACT_APP_NOTIFICATION_BASEURL,
  REACT_APP_PAYROLL_API_BASEURL,
  REACT_APP_QUESTIONNAIRE_API_BASEURL,
  REACT_APP_UM_BASEURL,
  REACT_APP_ANALYTICS_BASEURL,
  REACT_APP_USER_ACTIVITY,
  REACT_APP_SUPPORT_BASEURL,
  REACT_APP_CE_API_BASEURL,
  REACT_APP_RO_API_BASEURL,
} from './envConstants';

export const URL_CONSTANTS = {
  API: {
    BASE_URL: REACT_APP_API_BASEURL,
    BULLETIN: REACT_APP_BULLETIN_BASEURL,
    email: {
      downloadAttachment: '/email/manage/project/getAwsUrl',
    },
  },
  CRM: {
    baseUrl: REACT_APP_CRM_API_BASEURL,
    clientList: '/api/customer',
    CxPortalInviation: '/api/customer/send-invitation/',
    communication: {
      notes: {
        create: '/api/communication/note',
        getAll: '/api/communication/note',
      },
      sms: {
        create: '/api/communication/sms',
        getAll: '/api/communication/sms',
      },
      email: {
        create: '/api/communication/email',
        getAll: '/api/communication/email',
        downloadAttachment: '/api/communication/attachment',
      },
      callLog: {
        create: '/api/communication/call-log',
        getAll: '/api/communication/call-log',
        clientCallLog: '/api/communication/client-call-log',
        callStats: '/api/communication/call-stats',
        getCustomerDetails: '/api/communication/customer-details',
      },
    },
    paymentConfig: '/api/clients/payment-config',
    sendOnboardMail: '/api/clients/send-onboard-email',
    resendOnboardMail: '/api/clients/resend-onboard-email',
    checkOnboardingStatus: '/api/clients/check-onboard-status',
    generateOnboardLink: '/api/public/generate-onboarding-link',
    sendPaymentMail: '/api/payment/send-payment-mail',
    getAllPayment: '/api/payment/payment-list',
    updatePaymentStatus: '/api/payment/payment-status',
    sendCollectPayment: '/api/payment/collect-payment',
    projectLinkage: {
      getLinkedProjects: '/api/projects/get-linked-projects',
      setLinkProject: `/api/projects/set-linked-project`,
      unLinkProject: `/api/projects/unlinked-project`,
      linkConfig: `/admin-config`,
    },
    addClientSource: `/api/opportunity/source`,
    opportunityStatus: `/system/add-status`,
  },
  ENTITY: {
    BASE_URL: REACT_APP_CE_API_BASEURL,
    ENDPOINTS: {
      LIST: '/api/v1/form-module/fetch-entity',
      FORM_LISTS: '/api/v1/form-module/form-lists',
      FETCH_LAYOUT: '/api/v1/form-module/fetch-layout',
      DROP_DOWN_LIST: '/api/v1/custom-fields/get-all-list',
      REPORT_DATA: '/api/v1/form-module/report-data',
      DEFINITION_FIELDS: '/api/v1/custom-fields/get-all-list',
      CUSTOM_FIELD_OPTIONS_LIST: '/api/v1/custom-field-options/list',
      CREATE: '/api/v1/form-module/',
      UPDATE: '/api/v1/form-module/form-update',
      DELETE: '/api/v1/form-module/delete-form',
      EVENT_LOGS: '/api/v1/form-module/event-logs-data',
      AUDIT_LOGS: '/api/v1/form-module/audit-logs-data',
      GET_ENTITY_ROLE_MAPPING: '/api/v1/form-module/get-entity-role-mapping',
      UPDATE_ENTITY_ROLE_MAPPING: '/api/v1/form-module/entity-role-mapping',
      GET_FIELD_CONFIGS: '/api/v1/form-module/get-field-configs',
      UPDATE_FIELD_CONFIGS: '/api/v1/form-module/update-field-configs',
    },
  },
  SUPPORT: {
    BASE_URL: REACT_APP_SUPPORT_BASEURL,
    CLIENT_LIST_URL: `${REACT_APP_LOGIN_AUTH}/client-list`,
    TENANT_USERS_URL: `${REACT_APP_UM_BASEURL}/api/user-list/users?limit=1000&offset=0`,
    ENDPOINTS: {
      GET_STATUSES: '/api/ticket-statuses',
      GET_TYPES: '/api/ticket-types',
      GET_PRIORITIES: '/api/ticket-priorities',
      GET_TICKET_CREATORS: '/api/tickets/creators',
      GET_TICKETS: '/api/tickets',
      CREATE_TICKET: '/api/tickets',
      GET_POST_TICKET_COMMENTS: '/api/tickets/%s/comments',
      GET_AUDIT_LOG: '/api/tickets/%s/audit-logs',
      PUT_CC: '/api/tickets/%s/cc',
      PATCH_CLOSE_TICKET: '/api/tickets/%s/close',
      GET_TAGGABLE_USERS: '/api/tickets/%s/comments/taggableUsers',
    },
  },
  CHARGEBACK: {
    list: '/api/chargeback/list',
    projectSummary: {
      search: '/projects/chargeback/search-by-project-number?project_number=',
    },
    chargebackSummary: {
      chargebackReason: '/api/chargeback/reason/create',
      chargebackCreate: '/api/chargeback/create',
      getChargeback: '/api/chargeback',
    },

    baseUrl: REACT_APP_PAYROLL_API_BASEURL,
  },
  RETAINAGE: {
    baseUrl: REACT_APP_PAYROLL_API_BASEURL,
    get: `/api/user`,
  },
  CREW_MANAGEMENT: {
    baseUrl: REACT_APP_UM_BASEURL,
    crew: {
      get: `/api/user`,
    },
  },
  AUDIT_LOG: {
    baseUrl: REACT_APP_AUDIT_LOG_BASEURL,
    module: {
      getModules: '/audit-log/get-modules',
      getColumnsModule: '/audit-log/master-list',
      createConfiguration: '/audit-log',
      list: '/audit-log/list',
      deleteAudit: '/audit-log/',
      getRowData: '/audit-log/',
      updateConfiguration: '/audit-log',
      activeReportList: '/audit-log/active-report-list',
    },
  },
  COMPANY_CONFIG: {
    baseUrl: REACT_APP_API_BASEURL,
    getAll: `/admin-config`,
    getBySearch: `/admin-config`,
    getById: `/admin-config`,
    globalFilterSectionOptions: `/admin-config/global-filter-section-options`,
  },
  SSO_CONFIGURATION: {
    baseUrl: `${REACT_APP_API_BASEURL}/admin/sso/configuration`,
  },
  PROJECTS: {
    baseUrl: REACT_APP_API_PROJECT_BASEURL,
    dropdowns: {
      workroom: '/system/workroom',
      store: '/stores',
      category: '/projects/master/project-category',
      type: '/projects/master/project-type',
      status: '/system/cubes/master?cube=Project&dimension=status_id',
      installer: '/auth/user/report/get-installers',
      installerType: '/system/installer-work-type',
    },
    endPoints: {
      listCxScheduledProject: '/cx-scheduled/projects',
      acceptCxScheduledProject: '/cx-scheduled/project/%s/accept',
      declineCxScheduledProject: '/cx-scheduled/project/%s/decline',
      validateBusinessWorkHourAndHoliday:
        '/cx-scheduled/project/%s/execution/%s/validate-business-hours',
      validateCxSchedulingEligibleTechniciansByTypeCategoryStoreAndZipcode:
        '/cx-scheduled/project/%s/execution/%s/validate-technician-eligibility',
      validateTechnicianAvailableOnDate:
        '/cx-scheduled/project/%s/execution/%s/validate-technician-availibility',
      validateCalculatedTechnicianServiceAvailableTime:
        '/cx-scheduled/project/%s/execution/%s/validate-technician-service-time-availibility',
      validateAvailableTechnicianWithConsecutiveBreakTime:
        '/cx-scheduled/project/%s/execution/%s/validate-technician-availibility-with-break-time',
      validateTechnicianAfterTimeOff:
        '/cx-scheduled/project/%s/execution/%s/validate-technician-timeoff',
      validateTechnicianCapacity:
        '/cx-scheduled/project/%s/execution/%s/validate-technician-capacity',
      validateCustomerPortalDefaultRotationPercentage:
        '/cx-scheduled/project/%s/execution/%s/validate-technician-rotation-percentage',
      validateAndAssignInstaller:
        '/cx-scheduled/project/%s/execution/%s/validate-and-finalize',
      scheduleSlots: '/cx-scheduled/project/%s/date/%s/selected/%s/slots',
      scheduleTechnician: '/cx-scheduled/project/%s/schedule',
      reAssignInstaller: '/cx-scheduled/project/%s/execution/%s/reschedule',
      reAssignInstallerBeta:
        '/cx-scheduled/v1/project/%s/execution/%s/reschedule',
      statusCheck: '/cx-scheduled/project/%s/request/%s/start/%s/end/%s/status',
      scheduleSlotsBeta:
        '/cx-scheduled/v1/project/%s/date/%s/selected/%s/slots',
      scheduleBetaTechnician: '/cx-scheduled/v1/project/%s/schedule',
      statusCheckBeta:
        '/cx-scheduled/v1/project/%s/request/%s/start/%s/end/%s/status',
    },
    smsTab: {
      fetchSMSData: '/projects/%s/sms/scheduledMessage',
      patchSMS: '/projects/%s/sms/%s/scheduledMessage',
      fetchSMSHistory: '/projects/%s/sms/history',
      fetchSMSCount: '/projects/%s/sms/sms-count',
    },
    issuesTab: {
      fetchIssues: '/projects/%s/issues',
      fetchOriginatingFrom: '/system/originating-from',
      fetchIssueCategory: '/system/issue-category',
      urlWithIssueId: '/projects/%s/issues/%s',
      fetchItemsWithId: '/system/items/%s',
    },
    timeManagementTab: {
      fetchData: '/projects/%s/time-management',
    },
    notesTab: {
      notesURL: '/projects/%s/notes',
      notesURLWithId: '/projects/%s/notes/%s',
      fetchNotesType: '/system/notes-category',
      getMenuPermissionNotesType: '/system/notes-type',
    },
    merchandiseReturnTab: {
      fetchMerchandiseReturn: '/projects/%s/merchandise-return',
      createMerchandiseReturn: '/projects/%s/merchandise-return',
    },
    additionalFeeTab: {
      additionalCharge: '/projects/%s/payment-request/additional-charge',
      expenses: '/projects/%s/expenses',
      prTypes: '/system/pr-type',
      additionalChargeById: '/projects/%s/payment-request/additional-charge/%s',
      expenseSource: '/system/expense-source',
      expensesById: '/projects/%s/expenses/%s',
    },
    customer_notes: {
      sectionList: `/communication/project/%s/sections`, // GET
      closeSection: `/communication/project/%s/section/%s/close`, // PUT
      deleteSection: `/communication/project/%s/section/%s/delete`, // DELETE
      notesList: `/communication/project/%s/section/%s/notes`, // GET
      createNote: `/communication/project/%s/note`, // POST
      updateNote: `/communication/project/%s/section/%s/note/%s`, // PUT
      deleteNote: `/communication/project/%s/section/%s/note/%s/delete`, // DELETE
    },
  },
  PAYROLL: {
    report: '/payroll/report',
    action: '/payroll/action',
    downlaod: '/payroll/download',
    backgroundDownload: '/report/payroll',
  },
  QUESTIONNAIRE: {
    baseUrl: REACT_APP_QUESTIONNAIRE_API_BASEURL,
    endPoints: {
      getModules: '/api/questionnaire/module/list',
      getModuleById: '/api/questionnaire/module/%s',
      getModuleByTagName: '/api/questionnaire/module/tag/%s',
      getModuleByTagId: '/api/questionnaire/module/tag-id/%s',
      createModule: '/api/questionnaire/module',
      copyModule: '/api/questionnaire/module/copy',
      deleteModule: '/api/questionnaire/module/delete/%s',
      updateModuleById: '/api/questionnaire/module/%s',
      deleteModuleById: '/api/questionnaire/module/%s',
      uploadChecklistPdf: '/api/questionnaire/module/%s/target/%s/upload-pdf',

      getQuestions: '/api/questionnaire/module/%s/questions',
      getQuestionById: '/api/questionnaire/module/%s/question/%s',
      addQuestion: '/api/questionnaire/module/%s/question',
      updateQuestionById: '/api/questionnaire/module/%s/question/%s',
      deleteQuestions: '/api/questionnaire/module/%s/questions',
      deleteQuestionById: '/api/questionnaire/module/%s/question/%s',

      getAnswers: '/api/questionnaire/module/%s/target/%s/answers',
      getAnswerById: '/api/questionnaire/module/%s/target/%s/answer/%s',
      saveAnswers: '/api/questionnaire/module/%s/target/%s/answers',
      generateGeneralPO: '/api/questionnaire/module/%s/target/%s/generate',
      updateAnswers: '/api/questionnaire/module/%s/target/%s/answers',
      updateAnswerById: '/api/questionnaire/module/%s/target/%s/answer/%s',
      deleteAnswers: '/api/questionnaire/module/%s/target/%s/answers/%s',
      deleteAnswerById: '/api/questionnaire/module/%s/target/%s/answer/%s',
      createCustomizeCheckList:
        '/api/questionnaire/module/customizable-checklist',

      createGeneralPo:
        '/api/questionnaire/module/%s/target/%s/version/%s/order/%s',
      surveyInvite: '/api/questionnaire/project/%s/survey-invite',
      sendSurveySms: '/api/questionnaire/project/%s/send-survey-sms',
      sendChecklistSms: '/api/questionnaire/checklist/send-checklist-sms',
    },
  },
  EXPORTED_REPORTS: {
    report: '/report',
    reportList: '/report/list',
    downlaod: '/report/download?file=',
  },
  ITEM_SOURCE_COST_EACH: {
    baseUrl: REACT_APP_API_BASEURL,
    getItem: `/stores/store-items`,
    addItem: `/stores/store-item`,
    updateItem: `/stores/store-item`,
    deleteItem: `/stores/store-item`,
    getLaborList: `/system/item-types/2/items`,
  },
  Fcb2b: {
    getHistory: `/system/fcb2b/item/%s/history`,
    getItemById: `/system/fcb2b/item/%s/detail`,
    advanceSearch: '/system/items/search/advance',
  },
  CopyUserCoverage: {
    copyUser: `/auth/user/manage/copy-preferences`,
    addCoverage: `/auth/user/manage/coverage-preference`,
  },
  SERVICE_TIME: {
    baseUrl: REACT_APP_API_BASEURL,
    endPoints: {
      getServiceTimeConfig: '/admin-config/service-time/client/%s',
      addServiceTimeById: '/admin-config/service-time/client/%s/config/%s',
      addServiceTimeByFilter: '/admin-config/service-time/client/%s',
    },
  },
  CX_SCHEDULING: {
    baseUrl: REACT_APP_API_BASEURL,
    endPoints: {
      dayWiseSlotsCount: '/admin-config/cx-scheduling-slot/client/%s/counts', // get
      slotsByDay: '/admin-config/cx-scheduling-slot/client/%s/day/%s', // get
      addSlotInDay: '/admin-config/cx-scheduling-slot/client/%s/day/%s', // post
      updateSlotBySlotId: '/admin-config/cx-scheduling-slot/slot/%s/%s', // put
      deleteSlotBySlotId: '/admin-config/cx-scheduling-slot/slot/%s/%s', // delete
      mergeSlotsByDay:
        '/admin-config/cx-scheduling-slot/client/%s/day/%s/slot-merge',
    },
  },
  BUSINESS_HOURS: {
    baseUrl: REACT_APP_API_BASEURL,
    endPoints: {
      workHours: '/admin-config/business/work-hour/client/%s', // get
      addWorkHours: '/admin-config/business/work-hour/client/%s', // post
      holidays: '/admin-config/business/holiday-calendar/client/%s', // get
      addHoliday: '/admin-config/business/holiday-calendar/client/%s', // post
      technicianExistOnHoliday: '/projects/holiday/technician-exist', // post
      updateHolidayByHolidayId:
        '/admin-config/business/holiday-calendar/holiday/%s/%s', // put
      deleteHolidayByHolidayId:
        '/admin-config/business/holiday-calendar/holiday/%s/%s', // delete
      slotsByDay: '/admin-config/business-operation-slot/client/%s/day/%s', // get
      addSlotInDay: '/admin-config/business-operation-slot/client/%s/day/%s', // post
      updateSlotBySlotId: '/admin-config/business-operation-slot/slot/%s/%s', // put
      deleteSlotBySlotId: '/admin-config/business-operation-slot/slot/%s/%s', // delete
      mergeBusinessOperationSlotsByDay:
        '/admin-config/business-operation-slot/client/%s/day/%s/slot-merge',
    },
  },
  USER_META: {
    baseUrl: REACT_APP_API_BASEURL,
    endPoints: {
      createCategory: '/auth/user/manage/category',
      createSkill: '/auth/user/manage/skill',
      getAllCategories: '/auth/user/manage/category',
      getAllSkills: '/auth/user/manage/skill',
    },
  },
  ROUTES_PATH_CSV_UPLOAD: {
    GET_UPLOAD_TYPE_URL: '/csv-upload/upload-types',
    GET_UPLOADED_DATA_URL: '/csv-upload',
    POST_UPLOADED_DATA_URL: '/csv-upload',
    GET_PRESIGNED_CSV_URL: '/csv-upload/csv-presigned',
  },
  USER_MANAGEMENT: {
    baseUrl: REACT_APP_UM_BASEURL,
    filters: {
      filterList: `/api/user-list/users`,
    },
    endPoints: {
      workScheduleSlotsByHourId:
        '/auth/user/manage/work-schedule/%s/work-hour/%s/slots', // get
      addWorkScheduleSlotInHour:
        '/auth/user/manage/work-schedule/%s/work-hour/%s/slot', // post
      updateWorkScheduleSlotBySlotId:
        '/auth/user/manage/work-schedule/%s/slot/%s', // put
      deleteWorkScheduleSlotBySlotId:
        '/auth/user/manage/work-schedule/%s/slot/%s', // delete
      mergeWorkScheduleSlotsByHourId:
        '/auth/user/manage/work-schedule/%s/work-hour/%s/slot-merge', // post
      mergeAllWorkScheduleSlots:
        '/auth/user/manage/work-schedule/%s/slot-merge-all', // post

      userJobCoverageSlotsCount: `/auth/user/manage/job-coverage/%s/user-job-coverage/%s/slot-count`,
      userJobCoverageSlots:
        '/auth/user/manage/job-coverage/%s/user-job-coverage/slots', // get
      userJobCoverageSlotsByDay:
        '/auth/user/manage/job-coverage/%s/user-job-coverage/%s/value/%s/day/%s/slots', // get
      addUserJobCoverageSlotInDay:
        '/auth/user/manage/job-coverage/%s/user-job-coverage/%s/value/%s/day/%s/slot', // post
      updateUserJobCoverageSlotBySlotId:
        '/auth/user/manage/job-coverage/%s/slot/%s', // put
      deleteUserJobCoverageSlotBySlotId:
        '/auth/user/manage/job-coverage/%s/slot/%s', // delete
      mergeUserJobCoverageSlotByDay:
        '/auth/user/manage/job-coverage/%s/user-job-coverage/%s/value/%s/day/%s/slot-merge', // post
      mergeAllUserJobCoverageSlots:
        '/auth/user/manage/job-coverage/%s/user-job-coverage/%s/value/%s/slot-merge-all', // post
    },
  },

  DOCUMENT: {
    baseUrl: REACT_APP_DOCUMENTS_MS_API,
  },
  LOGIN: {
    baseUrl: REACT_APP_LOGIN_AUTH,
  },
  ONBOARD: {
    baseUrl: REACT_APP_LOGIN_AUTH,
    endpoints: {
      signup: '/onboard/client',
      tenants: '/get-all-user-tenants',
    },
  },
  ISSUES: {
    getSourceStatus: '/master/get-Status/list?statusType=Issue',
  },
  SCHEDULER_FILTERS: {
    saveAdminLevelFilter: '/admin-config/schedulerFilter/save',
    editAdminLevelFilter: '/admin-config/schedulerFilter/update/%s',
    getAdminLevelFilterById:
      '/admin-config/schedulerFilter/get-scheduler-info/%s',
    deleteAdminLevelFilter: '/admin-config/schedulerFilter/delete-filter/%s',
    setAdminLevelDefaultFilter:
      '/admin-config/schedulerFilter/update-status/%s',
    getAdminLevelFilterList: '/admin-config/schedulerFilter/list?%s',

    saveUserLevelFilter: '/admin-config/userSchedulerFilter/save/%s',
    editUserLevelFilter: '/admin-config/userSchedulerFilter/update/%s/%s',
    getUserLevelFilterById:
      '/admin-config/userSchedulerFilter/get-scheduler-info/%s/%s',
    deleteUserLevelFilter:
      '/admin-config/userSchedulerFilter/delete-filter/%s/%s',
    setUserLevelDefaultFilter:
      '/admin-config/userSchedulerFilter/update-status/%s/%s',
    setUserLevelTechnicianDefaultFilter:
      '/admin-config/userSchedulerFilter/update-restrict-technician/%s/%s',
    getUserLevelFilterList: '/admin-config/userSchedulerFilter/list/%s?%s',
    setUserLevelFilterApplyToDashboard:
      '/admin-config/userSchedulerFilter/update-apply-to-dashboard/%s/%s',

    getStoreList: '/master/get-Store/list?search=%s',
    getCategoryList: '/master/Get-Project-Category/list?search=%s',
    getProjectTypeList: '/master/get-Project-Type/list?search=%s',
    getProjectStatusList:
      '/master/get-Status/list?statusType=Project&search=%s',
    getSourceStatusList: '/master/get-Status/list?statusType=Source&search=%s',
    getDistrictList: '/master/Get-Store/district?search=%s',
    getWorkroomList: '/master/get-Workroom/list?search=%s',
    getCustomerList: '/customers?searchString=%s&offset=0&limit=10',
  },
  INVENTORY: {
    baseUrl: REACT_APP_INVENTORY_MS_API,
  },
  GLOBAL_FILTERS: {
    getDefaultFiltersById:
      '/admin-config/userSchedulerFilter/get-scheduler-info/%s',
  },
  NOTIFICATION: {
    baseUrl: REACT_APP_NOTIFICATION_BASEURL,
  },
  QUOTE_TEMPLATE: {
    baseUrl: REACT_APP_CRM_API_BASEURL,
    createQuoteTemplate: `/api/quotes-template/create`,
    updateQuoteTemplate: `/api/quotes-template/update`,
    deleteQuoteTemplate: `/api/quotes-template/delete`,
    getQuoteTemplateList: `/api/quotes-template/list`,
    getTemplateTagList: `/api/tags/list`,
    createTemplateTag: `/api/tags/create`,
  },
  ANALYTICS: {
    baseUrl: REACT_APP_ANALYTICS_BASEURL,
  },
  DYNAMIC_PROJECT_LAYOUT: {
    endPoints: {
      createProjectLayoutTemplate: '/admin-config/ui-template',
      fetchProjectLayout: '/admin-config/ui-template/%s',
      updateProjectLayout: '/admin-config/ui-template/%s',
      deleteProjectLayout: '/admin-config/ui-template/%s',
      updateRoleSettings: '/auth/role/%s',
      fetchTemplateByRole: '/admin-config/ui-template/get-template',
      cloneProjectLayoutTemplate: '/admin-config/ui-template/clone',
      setTemplateDefault: '/admin-config/ui-template/update-is-default/%s',
      fetchFields: '/admin-config/field-tagging',
      updateFieldAlias: '/admin-config/field-tagging/%s',
    },
  },
  BRAND_LOGO: {
    endPoints: {
      createBrandLogo: '/admin-config/brand-logo',
      crudBrandLogo: '/admin-config/brand-logo/%s',
    },
  },
  USER_ACTIVITY: {
    baseUrl: REACT_APP_USER_ACTIVITY,
    postUserActivity: `api/message/send-messages`,
    getReport: `api/message/user-activity-report`,
    exportReport: `report/user-activity`,
  },
  HELP_PAGE_CONFIG: {
    features: '/admin-config/pf-features%s',
    createFeature: '/admin-config/pf-features',
    featuresWithId: '/admin-config/pf-features/%s',
    featureWithModule: '/admin-config/pf-features/module/%s',
    featuresSequence:
      '/admin-config/feature-visibility/sequence?type=%s&group_id=%s&help_page=%s',
    postFeaturesSequence: '/admin-config/feature-visibility/sequence',
    onboardingProgress: '/admin-config/feature-visibility/onboarding-progress',
    groups: '/admin-config/feature-group?%s',
    createGroup: '/admin-config/feature-group',
    groupWithId: '/admin-config/feature-group/%s',
  },
  CUSTOMER_PROJECTS_LIST: {
    projectsListWithId: '/customers/project-list/%s%s',
    activeProjectsListWithId: '/customers/%s/active-projects%s',
  },
  DASHBOARD_PAGE: {
    widgetsList: '/dashboard/widget-templates/list/available-widgets%s',
  },
  DOCUMENT_CENTER: {
    documents: '/documents/templates',
    updateTemplates: '/documents/templates/update?type=%s',
    signatureUpdate: '/documents/templates/update-ready-signature-status',
    signAnywhereUpdate: '/documents/templates/update-sign-anywhere-status',
    documentsWithId: '/documents/templates/%s',
    fetchCategories: '/documents/templates/categories',
  },
  ENTITY_CONFIG: {
    baseUrl: REACT_APP_CE_API_BASEURL,
    fetchAllEntityList: '/api/v1/entity-type/list-all',
    fetchEntityListBySlug: '/api/v1/entity-type/list-all?slug=%s',
    fetchRelationshipListByEntityId:
      '/api/v1/custom-entity-mapping?entity_type_id=%s',
    baseRelationshipByEntityId: '/api/v1/custom-entity-mapping/%s',
    createRelationship: '/api/v1/custom-entity-mapping',
    fetchRelationshipListByParentEntityId:
      '/api/v1/custom-entity-mapping?parent_entity_type_id=%s',
  },
  RO: {
    baseUrl: REACT_APP_RO_API_BASEURL,
  },
  RECURRENCE: {
    postRecurrenceRruleConfigData: '/system/recurrence-project/%s/create',
    updateRecurringEvent: '/system/recurrence-project/update/%s',
    updateRecurringProject: '/system/recurrence-project/%s/project/%s',
    getRecurrenceGeneration: '/system/recurrence-project/%s/generation',
    getAuditLog: '/system/recurrence-project/%s/audit-log',
  },
};
